import axios from 'axios';

export function getJobs({ category, job_contract_type, departments, page }, options) {
    return axios.post('/annonces/recherche', {
        category,
        job_contract_type,
        departments,
        page,
    }, options).then(response => response.data);
}